<template>
    <v-card class="elevation-0">
        <v-toolbar card dense color="transparent">
            <v-toolbar-title><h5 v-t="'appMsg.notifications'"></h5></v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>

        <v-card-text class="pa-0">
            <v-list v-bind="{lines: true}" class="pa-0">
                <template v-for="(item, index) in notifications">
                    <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
                    <v-divider v-else-if="item.divider" :key="index"></v-divider>
                    <v-list-tile avatar v-else :key="item.title" @click="handleClick(item)">
                        <v-list-tile-avatar :color="item.color">
                            <v-icon dark>{{item.icon}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content style="max-width: 350px">
                            <v-list-tile-title v-html="item.title" style="font-size: 15px;"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.subtitle"
                                                   style="font-size: 12px;"></v-list-tile-sub-title>
                            <v-list-tile-sub-title v-html="item.timeLabel"
                                                   style="font-size: 12px; font-style: italic"></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
            <!--<v-divider></v-divider>
            <v-btn block flat class="ma-0" v-t="'appMsg.allNotifications'"></v-btn>
            <v-divider></v-divider>-->
        </v-card-text>
    </v-card>
</template>

<script>
   // import notes from '@/api/notification';

   export default {
      props: {
         notifications: Array,
         lines: {
            type: String,
            required: false,
            default: 'three-line'
         }
      },

      methods: {
         handleClick(notification) {
            window.getApp.$emit("APP_USER_NOTIFICATION_CLICK", notification);
         }
      },

   };

/* Data sample
      [
         {header: 'some section header'},
         {
            title: 'Cheques para depositar',
            color: 'blue',
            icon: 'fas fa-money-check-alt',
            subtitle: '4 cheques pendentes'
         }
         {divider: true, inset: true},
         {
            title: 'New client',
            color: 'indigo',
            icon: 'fas fa-user-friends',
            timeLabel: '24 min ago'
         },
         {divider: true, inset: true},
         {
            title: 'New message from Michael',
            color: 'green',
            icon: 'fas fa-comment',
            timeLabel: '1 hour ago'
         }
      ]
*/

</script>



// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/components/NotificationList.vue